<template>
  <layout>

    <div class="content">
      <b-card v-if="($account && $account.partner) || ($account && $account.company)" v-html="$t('partners.domain_iframe_text')">
      </b-card>
    </div>
  </layout>
</template>

<script>

export default {
  name: 'Test2',

  components: {},

  data() {
    return {}
  },

  computed: {},

  methods: {},
}
</script>
